import useMutationUpdateIntegrationMaintenanceConfig from './useMutationUpdateIntegrationMaintenanceConfig';
import useQueryIntegrationMaintenanceConfig from './useQueryIntegrationMaintenanceConfig';

const useIntegrationMaintenanceConfig = ({
  integrationId,
  optionsUseQueryIntegrationMaintenanceConfig,
  optionsUseMutationUpdateIntegrationMaintenanceConfig,
}: {
  integrationId: number;
  optionsUseQueryIntegrationMaintenanceConfig?: any;
  optionsUseMutationUpdateIntegrationMaintenanceConfig?: any;
}) => {
  const {
    data: integrationMaintenanceConfig,
    isLoading,
  } = useQueryIntegrationMaintenanceConfig(
    { integrationId },
    optionsUseQueryIntegrationMaintenanceConfig
  );
  const {
    isLoading: isUpdating,
    mutateAsync: update,
  } = useMutationUpdateIntegrationMaintenanceConfig(
    { integrationId },
    optionsUseMutationUpdateIntegrationMaintenanceConfig
  );

  return {
    isLoading,
    isUpdating,
    isWorking: isLoading || isUpdating,
    integrationMaintenanceConfig,
    update,
  };
};

export default useIntegrationMaintenanceConfig;
